import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout, ScrollToTop } from './components/layout';
import { Home, About, Services, Products, Contact, Careers, NotFound } from './pages';

/**
 * Main Application Component
 * Sets up routing and the main layout structure
 */
function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Main Pages */}
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="services" element={<Services />} />
          <Route path="services/:serviceId" element={<Services />} />
          <Route path="solutions" element={<Services />} />
          <Route path="solutions/:solutionId" element={<Services />} />
          <Route path="products" element={<Products />} />
          <Route path="contact" element={<Contact />} />
          <Route path="careers" element={<Careers />} />
          
          {/* Placeholder routes for additional pages */}
          <Route path="blog" element={<NotFound />} />
          <Route path="case-studies" element={<NotFound />} />
          <Route path="resources/*" element={<NotFound />} />
          <Route path="privacy" element={<NotFound />} />
          <Route path="terms" element={<NotFound />} />
          
          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
